import React from "react";
import plan from "../../../icons/planRequest.svg";
import visit from "../../../icons/visitRequest.svg";

function Oath(name) {
  return (
    <div className=" w-1/2 relative max-lg:w-full ">
      <div
        // style={{filter:'blur(12px)'}}
        className="flex flex-col justify-between gap-3   "
      >
        <div
          dir="rtl"
          className="flex flex-col bg-white font-body  p-5 rounded-xl gap-4  h-full max-lg:hidden "
        >
          <h2 className="text-[#005AC7] text-xl font-bold text-start max-lg:text-[0.875rem]">
            سوگندنامه
          </h2>

          <p className=" font-medium text-justify">
            {name?.Name} هستم.رسالت من به عنوان کارشناس بخش کشاورزی، ارائه آموزش
            صحیح، درست و به روز است. برای اعتلای کشاورزی ایران تلاش می‌کنم و
            اولویت من حفاظت از آب، خاک و محیط زیست میهن عزیزم است.
          </p>
        </div>
        <div className="bg-white flex flex-col font-body  rounded-xl p-5 gap-4 h-full">
          <h2 className="text-[#005AC7] text-xl font-bold text-start max-lg:text-[0.875rem]">
            خدمات کارشناس
          </h2>
          <div className="flex flex-row gap-2 justify-center">
            <button className="bg-[#00817A] flex flex-row px-2 py-4 gap-2 items-center w-48 justify-center rounded-xl cursor-default">
              <img alt="plan" src={plan} />
              <p className="text-white max-lg:text-[0.625rem] max-lg:font-bold">
                درخواست برنامه کودی
              </p>
            </button>
            <button className="bg-[#00A9BF] flex flex-row px-2 py-4 gap-2 items-center w-48 justify-center rounded-xl cursor-default">
              <img alt="visit" src={visit} />
              <p className="text-white max-lg:text-[0.625rem] max-lg:font-bold">
                درخواست بازدید
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Oath;
